module.exports = {"430407001":"人民街道","430407002":"青山街道","430407003":"潇湘街道","430407004":"五一街道","430407005":"合江街道","430407006":"黄沙湾街道","430407100":"角山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430407.json
// module id = 1959
// module chunks = 0